import { render } from "./ReferencesStep.vue?vue&type=template&id=dea8b708"
import script from "./ReferencesStep.vue?vue&type=script&lang=js"
export * from "./ReferencesStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__